import { GET_STATUSES, GET_PRODUCTS } from './mutation-types';

export default {
  [GET_STATUSES](state, statuses) {
    if (statuses) {
      state.statuses = statuses;
    }
  },

  [GET_PRODUCTS](state, data) {
    state.products = data.products;
    state.count = data.count;
    state.lastFilter = data.lastFilter;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/product/mutations.js